import { defineComponent as _defineComponent } from 'vue'
import { cva } from 'class-variance-authority'
import { computed } from 'vue'
import AppIcon from '../icon/AppIcon.vue'
import { IconSlug } from '../icon/iconMap'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppAlert',
  props: {
  level: null,
  message: null,
  description: null,
  icon: null,
  action: null
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;





const icon = computed(() => {
  if (props.icon) {
    return {
      name: props.icon,
    }
  }

  const iconMap: Record<typeof props.level, { name: IconSlug; variant?: 'filled' | 'outlined' }> = {
    success: { name: 'rounded-check', variant: 'filled' },
    warning: { name: 'alert' },
    error: { name: 'rounded-cancel' },
    info: { name: 'info', variant: 'filled' },
  }

  return iconMap[props.level]
})

const styles = cva([], {
  variants: {
    intent: {
      success: 'tw-border-positive [&>svg]:tw-fill-positive',
      warning: 'tw-border-warning [&>svg]:tw-fill-warning',
      error: 'tw-border-negative [&>svg]:tw-fill-negative',
      info: 'tw-border-secondary-dark [&>svg]:tw-fill-secondary-dark',
    },
  },
})

function actionClose() {
  emit('close')
}

return { __sfc: true,props, emit, icon, styles, actionClose, AppIcon }
}

})